const template = {
	choose_template: "Selecteer besturingssysteem of toepassing",
	default_category: "Overig",
	information_dialog: {
		title: "Meer informatie over template ",
	},
	other_os:
		"Is een besturingssysteem niet beschikbaar als sjabloon? Mogelijk kunnen we uw ISO uploaden. Maak een verzoek aan. Klik hier.",
	title: "Nieuwe VPS aanmaken",
};

export default template;
